module.exports = __webpack_public_path__ + "img/108ne.38b3ade7.svg";